import { api } from '../api.js';
import { el, openDialog } from '../dom.js';
import { t } from '../i18n.js';

// Name and city, and that is the whole form.
//
// There is no moderator behind it any more: the spam gate moved to the one
// scarce thing, `verified_at`, which is what lifts a page out of `/i/` and into
// the root. Existing is cheap; the pretty address is earned.
//
// The nickname is not asked for. A first form that demands a URL asks somebody
// to make an irreversible-feeling decision before they have seen the page it
// names — the server derives one, and the account page renames it later, which
// is where the warning about bio links belongs.
export async function openInstitutionForm({ onCreated }) {
  const cities = await api.get('/cities');

  const name = el('input', { id: 'if-name', type: 'text', required: true, autocomplete: 'off' });
  const city = el('select', { id: 'if-city' }, cities.map((row) => el('option', { value: row.id }, row.name)));

  const error = el('p', { class: 'pub-error', role: 'alert' });
  error.hidden = true;

  const submit = el('button', { class: 'button', type: 'submit' }, t.newInstitution);
  const abort = el('button', { class: 'button button-quiet', type: 'button' }, t.cancelAction);

  const form = el('form', { class: 'form' }, [
    el('h2', { class: 'dialog-title' }, t.newInstitution),
    error,
    el('div', { class: 'field' }, [el('label', { for: 'if-name' }, t.fieldVenueName), name]),
    el('div', { class: 'field' }, [el('label', { for: 'if-city' }, t.fieldCity), city]),
    el('p', { class: 'card-meta' }, t.newInstitutionHint),
    el('div', { class: 'row' }, [submit, abort]),
  ]);

  const dialog = openDialog(form);
  name.focus();

  abort.addEventListener('click', () => dialog.close());

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!name.value.trim()) return fail(t.institutionNameRequired);

    submit.disabled = true;
    try {
      const account = await api.post('/accounts', {
        name: name.value.trim(),
        cityId: Number(city.value),
      });
      dialog.close();
      await onCreated?.(account);
    } catch {
      submit.disabled = false;
      fail(t.createFailed);
    }
  });

  function fail(message) {
    error.textContent = message;
    error.hidden = false;
  }
}
